export const BYMD_AUTOSERVICE_AUTH_COOKIE = "BYMD-AUTOSERVICE-AUTH-COOKIE";

export const HEADER_X_XSRF_TOKEN = "X-XSRF-TOKEN"
export const BYMD_AUTOSERVICE_XSRF_COOKIE = "BYMD-AUTOSERVICE-XSRF-COOKIE";

export const COOKIE_CONSENT = "CookieFraudWarn";
export const COOKIE_MESSAGE = "CookieMessage";

export const DENY_INSTALL_PWA = "DenyInstallPWA";